<template>
  <div>
    <v-row class="mb-3 mt-3">
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-btn color="success" class="mb-2" v-if="!disableSave" @click="saveChanges()">Save Changes</v-btn>
        <v-btn color="warning" class="mb-2" v-if="!disableSave" @click="cancelEdit()">Cancel</v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-card-title class="pa-0">
          <v-spacer></v-spacer>
          <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
      </v-col>
    </v-row> -->
    <!-- BEGIN AOK Report table -->
    <v-data-table
      :headers="headers" 
      :search="filter" 
      :items="filteredItems"
      class="table-small elevation-1"
      :loading="loading">
      <template v-slot:no-data>No Data</template>
      <template v-slot:[`item.startDate`]="{ item }">
        <div @click="openEditItem(item, 'startDate')" v-if="item.startDateEdit === false">
          <td class="text-center">
            {{formatMonth(item.startDate)}} <v-icon class="cursor-pointer" color="secondary" x-small>edit</v-icon>
          </td>
        </div>
        <div v-else>
          <td class="text-xs-left" style="min-width:50px">
            <v-menu
              v-model="item.startCal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="input-field mt-3"
                  v-model="item.startDate"
                  append-icon="event"
                  readonly
                  dense
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="item.startDate"
                @input="item.startCal = false"
              ></v-date-picker>
            </v-menu>
          </td>
        </div>
      </template>
      <template v-slot:[`item.endDate`]="{ item }">
        <div @click="openEditItem(item, 'endDate')" v-if="item.endDateEdit === false">
          <td class="text-center">
            {{formatMonth(item.endDate)}} <v-icon class="cursor-pointer" color="secondary" x-small>edit</v-icon>
          </td>
        </div>
        <div v-else>
          <td class="text-center">
            <v-menu
              v-model="item.endCal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="input-field mt-3"
                  v-model="item.endDate"
                  append-icon="event"
                  readonly
                  dense
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="item.endDate"
                @input="item.endCal = false"
              ></v-date-picker>
            </v-menu>
          </td>
        </div>
      </template>
      <template v-slot:[`item.onboardKPI`]="{ item }">
        <div @click="openEditItem(item, 'onboardKPI')" v-if="item.onboardKPIEdit === false">
          <td class="text-center">
            {{item.onboardKPI}} <v-icon class="cursor-pointer" color="secondary" x-small>edit</v-icon>
          </td>
        </div>
        <div v-else>
          <v-text-field
            class="input-field mt-3"
            v-model="item.onboardKPI"
            v-on="on"
            dense
            outlined
          ></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.actualOnboarded`]="{ item }">
        <div :class="{'td-bg-red item-edit': item.lowonboardKPI, 'item-edit': !item.lowonboardKPI}">
          <td class="text-center">
            {{item.actualOnboarded}}
          </td>
        </div>
      </template>
      <template v-slot:[`item.achieved`]="{ item }">
        <td class="text-center">
          {{item.achieved}} %
        </td>
      </template>
      <template v-slot:[`item.coverageKPI`]="{ item }">
        <div class="item-edit" @click="openEditItem(item, 'coverageKPI')" v-if="item.coverageKPIEdit === false">
          <td class="text-center">
            {{item.coverageKPI}} <v-icon class="cursor-pointer" color="secondary" x-small>edit</v-icon>
          </td>
        </div>
        <div v-else>
          <v-text-field
            class="input-field mt-3"
            v-model="item.coverageKPI"
            v-on="on"
            dense
            outlined
          ></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.currentProgress`]="{ item }">
        <td class="text-center">
          {{item.currentProgress}} %
        </td>
      </template>
      <template v-slot:[`item.totalAchieved`]="{ item }">
        <td class="text-center">
          {{item.totalAchieved}} %
        </td>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <td class="text-center">
          <v-btn @click="$emit('viewInfluencers', item)" color="info" class="ims-action">
            <!-- <i class="fas fa-search" data-toggle="tooltip" data-placement="top" title="View Influencers"></i> -->
            <v-icon color="white" small data-toggle="tooltip" data-placement="top" title="View Influencers">people</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <!-- End AOK Report table -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import moment from 'moment'
import campaignAPIs from '../campaignAPIs';
export default {
  name: 'ReportTable',
  components: {
    Loading
  },
  props: [
    'headers',
    'filteredItems',
    'loading',
    'refresh'
  ],
  watch: {
    refresh(value) {
      if (value) this.unsetItemEdits()
    }
  },
  data () {
    return {
      disableSave: true,
      isLoading: false,
      filter: ''
    }
  },
  mounted() {
    this.unsetItemEdits()
  },
  methods: {
    saveChanges() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          const formData = this.buildFormData();
          // Submit request to save updated AOK Report data
          campaignAPIs
          .saveAOKReport(formData)
          .then(response => {
            // Update submitting status
            this.isLoading = false;
            // this.getPaymentConsolidateReport()
            this.cancelEdit()
            this.$emit('updated')
            // Show success message
            this.$swal({
              text: 'Report Updated',
              type: 'success'
            });
          })
          .catch(error => {
            // Update submitting status
            this.isLoading = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    buildFormData() {
      let editedItems = this.filteredItems.filter(item => {
        return item.editReport
      })
      let updateCampaignData = []
      editedItems.map(item => {
        updateCampaignData.push(Object.assign({}, {
          id: item.id,
          startDate: item.startDate,
          endDate: item.endDate,
          max_content: item.coverageKPI,
          kpi_onboarded: item.onboardKPI
        }))
      })
      let formData = new FormData();
      formData.append('campaigns', JSON.stringify(updateCampaignData));
      return formData
    },
    unsetItemEdits() {
      this.filteredItems = this.filteredItems.map(item => {
        item = this.setDefaultEditFields(item)
        return item
      })
    },
    setDefaultEditFields(item) {
      item.startDateEdit = false;
      item.endDateEdit = false;
      item.onboardKPIEdit = false;
      item.coverageKPIEdit = false;
      item.editReport = false;
      return item;
    },
    cancelEdit() {
      this.unsetItemEdits()
      this.disableSave = true
    },
    openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true
      item.editReport = true
      this.disableSave = false
      this.filteredItems = Object.assign([], this.filteredItems)
    },
    formatMonth(date) {
      if (!date) return '';
      return moment(date).format('MMM YYYY');
    }
  }
}
</script>
<style scoped>
  .table-small tbody td .input-field {
    font-size:13px;
  }
  .item-edit {
    min-width: 75px;
    min-height: 75px;
    padding-top: 30px;
  }

  .td-bg-red {
    background-color: #ff2c2c;
    padding-left: 10px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// ReportTable.vue?48e3c7fe